const getCompany = () => {
  try {
    const company = JSON.parse(sessionStorage.getItem("companyBulk"));

    if (isNaN(company.value) === false) {
      return company;
    }

    return { selected: {}, value: -1 };
  } catch (error) {
    return { selected: {}, value: -1 };
  }
};

export default getCompany;
